import { GlobalController } from 'src/shared/global/GlobalController'
import Transshipment from './Transshipment'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: ':link',
    name: 'transshipment',
    component: Transshipment,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
